import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LegalEntity} from '../../model/legal-entity.model';
import {PrivatePerson} from '../../model/private-person.model';

@Component({
  selector: 'app-edit-legal-entity',
  templateUrl: './edit-legal-entity.component.html',
  styleUrls: ['./edit-legal-entity.component.css']
})
export class EditLegalEntityComponent implements OnInit {
  @Input() legalEntity: LegalEntity;

  constructor(private matDialogRef: MatDialogRef<EditLegalEntityComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.legalEntity = data;
  }

  ngOnInit(): void {
  }

  isPrivatePerson() {
    return this.legalEntity instanceof PrivatePerson;
  }
}
